import{__assign as r}from"../../node_modules/tslib/tslib.es6.js";import{j as o}from"../../node_modules/react/jsx-runtime.js";import s from"@mui/material/CircularProgress";var e=function(e){return o.jsx(s,r({color:"primary"},e))};export{e as default};
//# sourceMappingURL=index.js.map
